import React from 'react';

export const InvalidBodyFields = ({ invalidIds }) => {
  const {
    invalid_field_ids,
    invalid_related_form_ids,
    invalid_form_meta,
    update_reference,
    other_malformed_tokens_present,
  } = invalidIds;
  return (
    <div className='mailer-field-warning row'>
      <div className='name' style={{ textAlign: 'center' }}>
        ATTENTION!
      </div>
      <div className='value'>
        {other_malformed_tokens_present && (
          <>
            <span>
              <i className='fa-solid fa-triangle-exclamation' /> Mailer fails to
              render all tokens. Please check for any malformed tokens.
              <br />
              Issues could be caused from unacceptable model/property names,
              casing, or other syntax errors...
            </span>
            <br />
          </>
        )}
        {update_reference && (
          <>
            <span>
              <i className='fa-solid fa-triangle-exclamation' /> Please ensure
              forms are properly linked, then insert linked form data for all{' '}
              {'{{UPDATE_FORM_REFERENCE}}'} instances.
            </span>
            <br />
            <br />
          </>
        )}
        {invalid_related_form_ids.length > 0 && (
          <>
            <span>
              <i className='fa-solid fa-triangle-exclamation' /> Please ensure
              forms are properly linked for the following related_forms:{' '}
              {invalid_related_form_ids.join(', ')}
            </span>
            <br />
            <br />
          </>
        )}
        {invalid_field_ids.length > 0 && (
          <>
            <span>
              <i className='fa-solid fa-triangle-exclamation' /> Mailer has
              field references that don't belong to the respective form or that
              no longer exist: {invalid_field_ids.join(', ')}
            </span>
            <br />
            <br />
          </>
        )}
        {invalid_form_meta.length > 0 && (
          <span>
            <i className='fa-solid fa-triangle-exclamation' /> Mailer has form
            metadata references that do not exist:{' '}
            {invalid_form_meta.join(', ')}
          </span>
        )}
      </div>
    </div>
  );
};
